import React, { Component, PureComponent } from 'react'
import styled from 'styled-components'
import Card from '../card'
import AdminCard from '../admin'
import './index.css'
import fs from 'fs'
import { categoriesArray } from '../../func/skills.js'

const Wrapper = styled.div`
  width: ${({ mediaQuery }) => (mediaQuery === 'smartphone' ? '100vw' : '65%')};
  max-width: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone' ? '100vw' : '600px'};
  height: 90vh;
  opacity: ${({ displaySearch }) => (displaySearch ? '0' : '1')};
  position: ${({ displaySearch }) => (displaySearch ? 'absolute' : 'relative')};
  left: ${({ displaySearch }) => (displaySearch ? '100vw' : '0')};
  overflow-y: scroll;
  overflow-x: hidden;
  padding-top: 2.5vh;
  transition: opacity 0.3s ease, left 0.3s ease;
  &::-webkit-scrollbar {
    display: none;
  }
`

const Letter = styled.div`
  font-size: 20px;
  text-transform: capitalize;
  padding: 5px 0 20px 40px;
`

const MemberTitle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: rgb(159, 156, 156);
  ${'' /* text-transform: capitalize; */}
  padding: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone' ? '15px 20px 5px 20px' : '15px 0 5px 40px'};
  cursor: pointer;
  display: flex;
  align-items: center;
`
const MemberSubTitle = styled.div`
  font-size: 15px;
  font-weight: bold;
  color: rgb(184, 183, 183);
  padding: ${({ mediaQuery }) =>
    mediaQuery === 'smartphone' ? '0px 20px 15px 20px' : '0px 0 15px 40px'};
  cursor: pointer;
  display: flex;
  align-items: center;
`

const Triangle = styled.div`
  margin-left: 25px;
  width: 0;
  height: 0;
  width: 0;
  height: 0;
  border-radius: 1px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid rgb(159, 156, 156);
  transform: ${({ isExpand }) => (isExpand ? '' : 'rotate(-90deg)')};
  transition: transform 0.5s ease;
`

const MemberWrapper = styled.div``

const ContentWrapper = styled.div`
  max-height: ${({ isExpand }) => (isExpand ? '30000px' : 0)};
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
`

let membersArr = [
  'Actif',
  'Adhérent',
  'Associé',
  'Honoraire',
  'Étudiant',
  'de droit',
  'error',
]

class Member extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isExpand: false,
    }
  }
  handleClick = () => {
    this.setState({
      isExpand: !this.state.isExpand,
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      this.setState({
        isExpand: false,
      })
    }
  }

  render() {
    return (
      <MemberWrapper>
        <MemberTitle
          onClick={this.handleClick}
          mediaQuery={this.props.mediaQuery}
        >
          {this.props.member === 'de droit'
            ? 'Conseillers des Ambassades étrangères ' +
              '(' +
              this.props.length +
              ')'
            : 'Membres ' +
              this.props.member +
              's ' +
              '(' +
              this.props.length +
              ')'}
          <Triangle isExpand={this.state.isExpand} />
        </MemberTitle>
        <MemberSubTitle mediaQuery={this.props.mediaQuery}>
          {this.props.member === 'Actif'
            ? '(journalistes titulaire de la carte de presse)'
            : ''}
          {this.props.member === 'Adhérent'
            ? '(rédacteurs non titulaires de la carte de presse, etc)'
            : ''}
          {this.props.member === 'Associé'
            ? '(dirigeants et communicants)'
            : ''}
          {this.props.member === 'Honoraire' ? '(retraités passionnés)' : ''}
        </MemberSubTitle>
        <ContentWrapper isExpand={this.state.isExpand}>
          {this.props.data.map((item, i) => {
            if (this.props.data[i - 1] && this.props.member !== 'error') {
              if (
                item.lastname &&
                item.lastname.split('').length > 0 &&
                this.props.data[i - 1].lastname &&
                this.props.data[i - 1].lastname.split('').length > 0
              ) {
                if (
                  item.lastname[0].toLowerCase() !==
                  this.props.data[i - 1].lastname[0].toLowerCase()
                ) {
                  return (
                    <div key={i}>
                      <Letter>{item.lastname[0]}</Letter>
                      <Card
                        mediaQuery={this.props.mediaQuery}
                        item={item}
                        modifyMember={(id, member) =>
                          this.props.modifyMember(id, member, item)
                        }
                        deleteMember={(id) => this.props.deleteMember(id)}
                        admin={this.props.admin}
                      />
                    </div>
                  )
                }
              }
            } else if (!this.props.data[i - 1]) {
              return (
                <div key={i}>
                  <Letter>{item.lastname[0]}</Letter>
                  <Card
                    item={item}
                    mediaQuery={this.props.mediaQuery}
                    modifyMember={(id, member) =>
                      this.props.modifyMember(id, member, item)
                    }
                    deleteMember={(id) => this.props.deleteMember(id)}
                    admin={this.props.admin}
                  />
                </div>
              )
            }
            return (
              <div key={i}>
                <Card
                  item={item}
                  mediaQuery={this.props.mediaQuery}
                  deleteMember={(id) => this.props.deleteMember(id)}
                  modifyMember={(id, member) =>
                    this.props.modifyMember(id, member, item)
                  }
                  admin={this.props.admin}
                />
              </div>
            )
          })}
        </ContentWrapper>
      </MemberWrapper>
    )
  }
}

class Users extends Component {
  constructor(props) {
    super(props)
    this.state = {
      Associé: 0,
      Adhérent: 0,
      Actif: 0,
      Honoraire: 0,
      'de droit': 0,
      Érudiant: 0,
      error: 0,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      nextProps.members === this.props.members &&
      nextProps.admin === this.props.admin &&
      nextProps.displaySearch === this.props.displaySearch
    ) {
      return false
    } else {
      return true
    }
  }

  render() {
    return (
      <Wrapper
        mediaQuery={this.props.mediaQuery}
        displaySearch={this.props.displaySearch}
      >
        {membersArr.map((memberType, i) => {
          if (this.props.members[memberType] !== undefined) {
            if (memberType === 'error' && !this.props.admin) {
              return <div />
            } else {
              return (
                <Member
                  member={memberType}
                  mediaQuery={this.props.mediaQuery}
                  key={i}
                  newCat={categoriesArray()}
                  modifyMember={(id, member, prevMember) =>
                    this.props.modifyMember(id, member, prevMember)
                  }
                  deleteMember={(id) => this.props.deleteMember(id)}
                  data={this.props.members[memberType]}
                  admin={this.props.admin}
                  length={this.props.members[memberType].length}
                />
              )
            }
          }
        })}
      </Wrapper>
    )
  }
}

export default Users



// WEBPACK FOOTER //
// ./src/components/users/index.js